import { render, staticRenderFns } from "./NewsCom.vue?vue&type=template&id=78e281dc&scoped=true&"
import script from "./NewsCom.vue?vue&type=script&lang=js&"
export * from "./NewsCom.vue?vue&type=script&lang=js&"
import style0 from "./NewsCom.vue?vue&type=style&index=0&id=78e281dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e281dc",
  null
  
)

export default component.exports